// 保存数据
const SAVE_DATA = 'save_data'
// 保存文章
const REQUEST_SAVE_ARTICLE = 'request_save_article'
// 播放
const CANVASPLAY = 'canvasPlay'
// 改变多音字
const CHANGE_POLYPHONE = 'change_polyphone'
// 改变数字读法
const CHANGE_NUMBER = 'change_number'
// 选择文字模板
const SELECT_TEXT_TEMPLATE = 'select_text_template'
// 编辑文字模板
const EDIT_TEXT_TEMPLATE = 'edit_text_template'
// 显示编辑样式设置弹窗
const SHOW_STYLE_POPUP = 'show_style_popup'
// 添加封面文字
const ADD_COVER_TEXT = 'add_cover_text'
// 更新智能文案结果
const UPDATE_ARTICLE_AI = 'update_article_ai'

export default {
  SAVE_DATA,
  REQUEST_SAVE_ARTICLE,
  CANVASPLAY,
  CHANGE_POLYPHONE,
  CHANGE_NUMBER,
  SELECT_TEXT_TEMPLATE,
  EDIT_TEXT_TEMPLATE,
  SHOW_STYLE_POPUP,
  ADD_COVER_TEXT,
  UPDATE_ARTICLE_AI
}